import { styled } from "baseui";

export const FieldRowWrapper = styled("div", () => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
}));
